import { commonActions } from '../../../../global-store/subjects/common';
import logger from '../../../../services/logging/logging-service';
import { isSetOnLocalStorage, WPN_STATUS, PL_DAILY_SESSION, WPN_DAILY_SESSION } from '../../../../utils/local-storage';
import { setOptionsFromSdk } from '../../../../utils/push-notifications-utils';
import { unHideElement } from '../../../../utils/dom-utils';
import { isPremiumPage } from '../../../../utils/aem-utils';
import { retry } from '../../../../utils/retry';

const WPN_EDIT_LABEL = '#WPNEditLabel';
const $slimBannerBottomWPN = document.querySelector('#slimBannerBottomWPN');
const isSlimBannerBottomWPNOnPage = Boolean($slimBannerBottomWPN);

export const initInDialog = async ({ actions, htmlProps, selectBoxes, sdk, handlers, onShowConfirmModal }) => {
  retry({
    maxAttempts: 3,
    checkEvery: 5000,
    checkFunction: () => document.querySelector(WPN_EDIT_LABEL),
  })
    .then(() => {
      const $WPNEdit = document.querySelector(WPN_EDIT_LABEL);
      unHideElement($WPNEdit?.parentNode);
      $WPNEdit?.addEventListener('click', () => {
        handlers.handleWPNEditClick(selectBoxes);
      });

      if (
        !isSetOnLocalStorage(WPN_STATUS.OBJECT_KEY) &&
        !isSetOnLocalStorage(WPN_DAILY_SESSION.OBJECT_KEY) &&
        isSetOnLocalStorage(PL_DAILY_SESSION.OBJECT_KEY)
      ) {
        commonActions.setPushNotificationInDialogShow(false);
        return;
      }

      if (
        !isSlimBannerBottomWPNOnPage &&
        !(Notification.permission === 'denied') &&
        sdk?.canRegister &&
        !sdk?.channel?.optedIn &&
        !isSetOnLocalStorage(WPN_STATUS.OBJECT_KEY) &&
        !isSetOnLocalStorage(WPN_DAILY_SESSION.OBJECT_KEY) &&
        !isPremiumPage()
      ) {
        onShowConfirmModal();
      } else {
        setOptionsFromSdk({ sdk, selectBoxes: htmlProps.selectBoxes, actions });
        commonActions.setPushNotificationInDialogShow(false);
      }
    })
    .catch((e) => logger.error('[WPN] Edit label wont be shown', e));
};
